import { render, staticRenderFns } from "./CustomInvoices.vue?vue&type=template&id=03c327e6&scoped=true"
import script from "./CustomInvoices.vue?vue&type=script&lang=js"
export * from "./CustomInvoices.vue?vue&type=script&lang=js"
import style0 from "./CustomInvoices.vue?vue&type=style&index=0&id=03c327e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c327e6",
  null
  
)

export default component.exports